<template>
    <form
        id="legal-data"
        class="cabinet-settings supplier-tab hide"
        data-title="Юридические данные"
        @submit.prevent="onUpdateUser()"
    >
        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label required" for="title"
                >Наименование</label
            >
            <input
                id="title"
                v-model="company_name"
                type="text"
                class="cabinet-form-group__input large"
                :class="{
                    error:
                        ($v.company_name.$dirty && $v.company_name.$invalid) ||
                        errors.updateLegal.company_name
                }"
            />
            <div
                v-if="$v.company_name.$dirty && $v.company_name.$invalid"
                class="error-label"
            >
                Введите корректное наименование
            </div>
            <div v-if="errors.updateLegal.company_name" class="error-label">
                {{ errors.updateLegal.company_name[0] }}
            </div>
        </div>
        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label required" for="address"
                >Адрес</label
            >
            <input
                id="address"
                v-model="address"
                type="text"
                class="cabinet-form-group__input large"
                :class="{
                    error:
                        ($v.address.$dirty && $v.address.$invalid) ||
                        errors.updateLegal.address
                }"
            />
            <div
                v-if="$v.address.$dirty && $v.address.$invalid"
                class="error-label"
            >
                Введите корректный адрес
            </div>
            <div v-if="errors.updateLegal.address" class="error-label">
                {{ errors.updateLegal.address[0] }}
            </div>
        </div>
        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label disabled" for="inn"
                >ИНН</label
            >
            <input
                id="inn"
                v-model="inn"
                type="text"
                class="cabinet-form-group__input disabled large"
                disabled=""
            />
        </div>
        <div class="product-form__btn-wrap">
            <button
                type="submit"
                class="cabinet-btn product-form__btn"
                :class="{ loading: loading }"
                :disabled="loading"
            >
                Сохранить изменения
            </button>
        </div>
    </form>
</template>

<script>
import { required, email, maxLength } from 'vuelidate/lib/validators'
import checkDemoUser from '@/mixins/checkDemoUser.js'

import { mapState, mapActions } from 'vuex'

export default {
    name: 'RetailerLegalData',
    mixins: [checkDemoUser],
    data() {
        return {
            company_name: '',
            address: '',
            inn: '',
            loading: false
        }
    },
    validations: {
        address: { required },
        company_name: { required }
    },
    computed: {
        ...mapState('user', ['user', 'errors'])
    },
    watch: {
        user: {
            handler: function(val) {
                this.setUserFields()
            },
            deep: true
        }
    },
    mounted() {
        this.setUserFields()
    },
    methods: {
        ...mapActions('user', ['updateLegal']),
        setUserFields() {
            this.company_name = this.user ? this.user.retailer.LegalName : ''
            this.address = this.user ? this.user.address : ''
            this.inn = this.user ? this.user.inn : ''
        },
        async onUpdateUser() {
            if (this.loading) return

            if (this.isDemoUserMode()) return

            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.loading = true
                await this.updateLegal({
                    company_name: this.company_name,
                    address: this.address,
                    inn: this.inn
                })
                this.loading = false
                this.$notify({
                    title: 'Профиль',
                    type: 'success',
                    text: 'Успешно обновлен'
                })
            } else {
                console.log('Form not valid')
            }
        }
    }
}
</script>
